import { PROJECTION } from './Constants';

const calculateArea = d => {
  const count = d.UGDS || 0;
  const minimalCount = Math.max(1000, count);
  const cappedCount = Math.min(70000, minimalCount);

  const area = Math.max(1, cappedCount / 900);
  return area;
};

const calculateLocation = d => {
  if (!d.LATITUDE || !d.LONGITUDE) {
    return null;
  }

  const lat = +d.LATITUDE;
  const long = +d.LONGITUDE;

  if (typeof lat !== 'number' || typeof long !== 'number') {
    return null;
  }

  return PROJECTION([long, lat]);
};

export { calculateArea, calculateLocation };



// WEBPACK FOOTER //
// ./src/App/Calculations.js